import axios from "axios";
const API_URL = "https://api.eliteshippingtracker.com/v1/";
const getOrder = (values) => {
  return axios.post(
    `${API_URL}voucher-info`,
    {
      certificate: values.field2,
      order_number: values.field1,
      id: values?.id || "",
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

const getOrderByInfo = (values) => {
  return axios.post(
    `${API_URL}basic-info`,
    {
      fname: values.fname,
      lname: values.lname,
      email: values.email,
    },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};

const adminLogin = (values) => {
  return axios.post(
    `${API_URL}login`,
    {
      username: values.username,
      password: values.password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const adminForgotPass = (values) => {
  return axios.post(
    `${API_URL}forgot-password`,
    {
      email: values.username,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const resetAdminPassword = (pass, token) => {
  return axios.put(
    API_URL + "update-password/" + token,
    {
      password: pass,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const resetToekenVerify = (token) => {
  return axios.get(
    API_URL + "check-forgot-token/" + token,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const uploadOrdersSyg = (formData) => {
  return axios.post(`${API_URL}import-sheet-syg`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const uploadOrdersOtb = (formData) => {
  return axios.post(`${API_URL}import-sheet-otb`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const importOtbMasterSheet = (formData) => {
  return axios.post(`${API_URL}import-otb-master-sheet`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const importSYGMasterSheet = (formData) => {
  return axios.post(`${API_URL}import-syg-master-sheet`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const updateOrders = (values, id, adminId) => {
  return axios.put(
    `${API_URL}pavlina-record-track/${id}`,
    {
      adminId: adminId,
      first_name: values.fname,
      last_name: values.lname,
      certificate: values.certificate,
      city: values.city,
      email: values.email,
      company: values.company,
      job: values.job,
      state: values.state,
      zip: values.zip,
      account: values.account,
      product: values.product,
      prod_qty: values.qty,
      price: values.price,
      expiry_date: values.expiry,
      address1: values.address,
      value: values.value,
      redemption_date: values.redeemp,
      delivery_date: values.delivery,
      order_number: values.order_no,
      order_status: values.status,
      tracking_number: values.tracking_no,
      shipping_provider: values.provider,
      provider: values.card_provider,
      phone: values.phone,
      address2: values.address2,
      sku: values.sku,
      order_date: values.vender_date,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const listOrdered = (limit, page, values, order_status) => {
  return axios.get(
    `${API_URL}list-orders?limit=${limit}&page=${page}${
      order_status ? "&order_status=" + order_status : ""
    }${
      values?.fieldtype && values?.searchval
        ? "&" + values.fieldtype + "=" + values.searchval
        : ""
    }`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const listOrderedNew = (limit, page, values) => {
  return axios.get(
    `${API_URL}pavlina-record-track?limit=${limit}&page=${page}&order_status=${values.status}&ordering_agent=${values.ordering_agent}&provider=${values.card_provider}&certificate=${values.certificate}&job=${values.job}&website=${values.website}&state=${values.state}&city=${values.city}&email=${values.email}&phone=${values.phone}&value=${values.value}&zip=${values.zip}&address1=${values.address}&address2=${values.address2}&company=${values.company}&first_name=${values.fname}&expiry_date=${values.expiry}&last_name=${values.lname}&shipping_provider=${values.provider}&price=${values.price}&redemption_date=${values.redeemp}&order_number=${values.order_no}&account=${values.account}&prod_name=${values.product}&product_type=${values.product_type}&delivery_date=${values.delivery}&prod_qty=${values.qty}&prod_sku=${values.sku}&tracking_number=${values.tracking_no}&type=${values.type}&source=${values.source}&order_date=${values.vender_date}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const listOtbOrders = (limit, page) => {
  return axios.get(
    `${API_URL}pavlina-record-track?limit=${limit}&page=${page}&ordering_agent=OTB`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const listSYGOrders = (limit, page) => {
  return axios.get(
    `${API_URL}pavlina-record-track?limit=${limit}&page=${page}&ordering_agent=SYG`,
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const listProducts = (limit, page, values, letter = "") => {
  return axios.get(
    `${API_URL}list-products?limit=${limit}&page=${page}&startswith=${letter}${
      values?.fieldtype && values?.searchval
        ? "&" + values.fieldtype + "=" + values.searchval
        : ""
    }`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const listProductById = (id) => {
  return axios.get(
    `${API_URL}product/${id}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const addProduct = (formData) => {
  return axios.post(`${API_URL}add-product`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const uploadProduct = (formData, id) => {
  return axios.post(`${API_URL}update-product/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
const listAllProducts = () => {
  return axios.get(`${API_URL}all-products`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const listAllAccountants = () => {
  return axios.get(`${API_URL}all-accounts`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getProductInfoById = (id) => {
  return axios.get(`${API_URL}pavlina-certificate-track/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const deleteAllOrder = (id) => {
  return axios.delete(`${API_URL}delete-all-orders`, {
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      deleted_by: id,
    },
  });
};
const deleteOrderById = (id) => {
  return axios.get(`${API_URL}del-order/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const deleteSelectedOrders = (id) => {
  return axios.post(
    `${API_URL}del-selected-orders`,
    { ids: id },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const deleteProductsById = (id, uId) => {
  return axios.delete(`${API_URL}product/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      adminId: uId,
    },
  });
};

const emailSendForOrder = (id, status) => {
  return axios.get(`${API_URL}send-email/${id}/${status}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};

const getUpdatedOrderInfo = (id) => {
  return axios.get(`${API_URL}refresh-order/${id}`, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
const unsubscribeEmail = (id) => {
  return axios.put(
    `${API_URL}unsubscribe/${id}`,
    {},
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};

const getLoginAzureLink = (loginWith) => {
  return axios.get(
    `${API_URL}auth/${loginWith}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const getAzureLoginUserInfo = (id, type) => {
  return axios.get(
    `${API_URL}verify/${type}/${id}`,

    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
};
const AdminListService = {
  getLoginAzureLink,
  getAzureLoginUserInfo,
  getOrder,
  getOrderByInfo,
  adminLogin,
  adminForgotPass,
  resetAdminPassword,
  resetToekenVerify,
  uploadOrdersSyg,
  uploadOrdersOtb,
  importOtbMasterSheet,
  importSYGMasterSheet,
  listOrdered,
  listProducts,
  listProductById,
  listAllProducts,
  listAllAccountants,
  listOrderedNew,
  getProductInfoById,
  updateOrders,
  deleteAllOrder,
  deleteOrderById,
  deleteSelectedOrders,
  deleteProductsById,
  uploadProduct,
  addProduct,
  emailSendForOrder,
  getUpdatedOrderInfo,
  unsubscribeEmail,
  listOtbOrders,
  listSYGOrders,
};

export default AdminListService;
